module.exports = __webpack_public_path__ + "static/media/img-7.8621cbc9.jpg";